// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"iP-z","inlineTitle":"jP-z","sponsoredAdsWrapper":"kP-z","marketplaceRecosWrapper":"lP-z"};